import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=3a8d0e0f&scoped=true&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"
import style0 from "./Icon.vue?vue&type=style&index=0&id=3a8d0e0f&scoped=true&lang=css&"
import style1 from "./Icon.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d0e0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a8d0e0f')) {
      api.createRecord('3a8d0e0f', component.options)
    } else {
      api.reload('3a8d0e0f', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=3a8d0e0f&scoped=true&", function () {
      api.rerender('3a8d0e0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Avatar/Icon.vue"
export default component.exports